export const previewThemeChanged = `
  subscription PreviewThemeChanged {
    previewThemeChanged {
      session
      theme
      customization_settings {
        appearance
        button_style
        brand_colors_dark
        brand_colors_light
        brand_text_colors_dark
        brand_text_colors_light
        font
        submit_button_type
        submit_button_text_pay_in
        submit_button_text_pay_out
        layout
        amount_field_type
        currency_display_format
        payment_methods_view
        render_typ_image
        preselect_first_payment_method
        preselect_only_available_method
        show_decline_reason_typ
        show_both_currency_limits
        show_default_cardholder_on_pano
        show_transaction_date
        show_transaction_fees
        show_payment_method_fees
        show_payment_method_limits
        show_total_amount
        show_bonus_received
        show_payment_instrument
        show_balance
        show_billing_descriptor
        input_field_style
        payment_instrument_display
        payment_instrument_component_style
        show_card_expiry
        header_style
        promocode
        promocode_configuration {
          enabled
          type
        }
        quick_amount_options {
          enabled
          type
          configuration
        }
        policies_data {
          render_policies_data
          support_website
          support_email
          support_phone
          privacy_policy_url
          terms_of_service_url
          __typename
        }
        last_used_method_first
        currency_display_mode
        show_validation_below_fields
        billing_information_separate_page
        payment_instrument_display
        allow_payment_instrument_removal
        show_instrument_removal_confirmation_modal
        show_back_button
        show_close_button
        __typename
      }
      billing_info_settings {
        country
        customer_name
        email
        phone
        zip
        state
        city
        address
        __typename
      }
      __typename
    }
  }
`;
export const previewPageStateChanged = `
  subscription PreviewPageStateChanged {
    previewPageStateChanged {
      session
      activePage
      paymentFormPage {
        _
        __typename
      }
      transactionStatusPage {
        type
        renderTypImage
        __typename
      }
      __typename
    }
  }
`;
